<div class="p-3">
    <div class="row border-bottom">
        <h6 class="px-3"><b>{{ isEdit ? 'Update Immigration activity':'Create Immigration activity'}}</b></h6>
    </div>
    <form [formGroup]="createForm" class="d-flex flex-column row">
        <div class="row m-0 pt-2">

            <div class="col-4">
                <label>Activity type *</label>
                <ng-select [items]="activityTypes" [closeOnSelect]="false" [multiple]="false" bindLabel="displayText"
                    bindValue="id" formControlName="activityType">
                </ng-select>
            </div>

            <div class="col-2">
                <label>Order *</label>
                <input type="number" class="w-100 form-control form-control-sm" formControlName="order" />
            </div>

        </div>
        <div class="row m-0 py-2">
            <div class="col">
                <label>Header *</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="header"></textarea>
            </div>
            <div class="col">
                <label>Description *</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="description"></textarea>
            </div>
        </div>
        <div class="row m-0 py-2">
            <div class="col">
                <label for="active">Country *</label>
                <ng-select [items]="countries" [multiple]="false" bindLabel="displayText" formControlName="country"
                    bindValue="id" (change)="onCountryChange()">
                </ng-select>
            </div>

            <div class="col">
                <label for="active">Visa type *</label>
                <ng-select [items]="visaTypes" [multiple]="false" bindLabel="displayText" bindValue="id"
                    formControlName="visaTypes" (change)="onVisaChange($event)">
                </ng-select>
            </div>
        </div>

        <div class="row m-0">
            <div class="px-3">
                <label for="active">
                    <input id="active" type="checkbox" formControlName="isActive" />
                    Active
                </label>
            </div>
        </div>

        <div class="border-top">
            <div class="px-3"><b>Additional information</b></div> 
            <div class="row m-0 py-2">
                <div class="col">
                    <label>Office Location</label>
                    <ng-select [items]="officeToBeVisited" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="displayText" bindValue="id" formControlName="officeToBeVisited">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Legal entity</label>
                    <ng-select [items]="officeLE" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="officeLE">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Rank</label>
                    <ng-select [items]="rank" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="rankName" bindValue="rankCode" formControlName="rank">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                <span class="ng-value-label">
                                    {{item.rankName}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">+{{items.length - 1}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>              
            </div>          
            <div class="row m-0">               
                <div class="col">
                    <label>Nationality</label>
                    <ng-select [items]="nationality" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="nationality">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Nationality Type</label>
                    <ng-select [items]="nationalityType" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="nationalityType">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">+{{items.length - 1}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Excluded nationality</label>
                    <ng-select [items]="nationality" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="excludedNationality">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row m-0">
                <div class="col">
                    <label>Gender</label>
                    <ng-select [items]="gender" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="gender">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Current visa status</label>
                    <ng-select [items]="currentVisaStatus" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="displayText" bindValue="id" formControlName="currentVisaStatus">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Short term visa</label>
                    <ng-select [items]="shortTermVisa" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="shortTermVisa">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row m-0">
                <div class="col-md-4">
                    <label>Type of support</label>
                    <ng-select [items]="typeOfSupport" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="typeOfSupport">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <label>Employee current location</label>
                    <ng-select [items]="employeeCurrentLocation" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="displayText" bindValue="id" formControlName="employeeCurrentLocation">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col">
                    <label>Immigration case type</label>
                    <ng-select [items]="immigrationCaseType" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="displayText" bindValue="id" formControlName="immigrationCaseType">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>           
        </div>


        <div class="row my-3 text-center">

            <div class="p-3 col">
                <button *ngIf="!isEdit" (click)="createActivity()" eosDebounce [disabled]="!createForm.valid"
                    class="btn btn-secondary mx-2" type="submit">Create</button>
                <button *ngIf="isEdit" (click)="updateActivity()" eosDebounce [disabled]="!createForm.valid"
                    class="btn btn-secondary mx-2" type="submit">Update</button>
                <button class="btn btn-outline-primary me-2" (click)="onCancel()">
                    Close</button>
            </div>
        </div>





    </form>
</div>
